import { MutationTree } from "vuex";
import { UserStateInterface } from "./state";

const mutation: MutationTree<UserStateInterface> = {
  setStateByKey(state: any, { key, value }) {
    // console.log("UserModule SET", key, value);
    state[key] = value;
  },
};

export default mutation;
